import { ComponentPropsWithoutRef, FC } from 'react';
import { twMerge } from 'tailwind-merge';

type CardProps = ComponentPropsWithoutRef<'article'>;

export const Card: FC<CardProps> = ({ className, ...rest }) => (
  <article {...rest} className={twMerge('rounded-xl border border-gray-200 bg-white-100 drop-shadow-sm flex p-5', className)} />
);
